import { ImageOverlay } from 'leaflet';
import sanitize from 'sanitize-html';

export class ImageOverlayEx extends ImageOverlay {
  private defaultClassNames: string[] = [];

  _initImage(): void {
    this._image = new Image();
    this.defaultClassNames.push('leaflet-image-layer');
    if (this._zoomAnimated) {
      this.defaultClassNames.push('leaflet-zoom-animated');
    }

    this._image.onload = this.handleOnLoad;

    this.setClassName(this.options.className);

    if (this.options.zIndex) {
      this._updateZIndex();
    }

    this._image.src = sanitize(this._url);
  }

  setUrl(url: string): this {
    this._url = url;

    if (this._image) {
      this._image.src = '';
      this._image.src = sanitize(url);
    }
    return this;
  }

  setClassName(className?: string): this {
    const classNames = [...this.defaultClassNames, className];
    this._image.setAttribute('class', classNames.filter((x) => x !== undefined).join(' '));

    return this;
  }

  handleOnLoad = (): void => {
    this.fire('load');
  };
}
